import {Avatar, Box, Button, Card, Divider, Drawer, Flex, Group, Text} from "@mantine/core";
import React, {useState} from "react";
import {RentContract} from "../../../models/RentContract";
import {downloadDocument} from "../../../Services/RentContractDocumentService";
import {UploadDocuments} from "./UploadDocuments";
import {IconDownload, IconFile} from "@tabler/icons-react";


interface RentContractDocumentProbs {
    onCreatedRentContractDocument: () => void; // callback after successful creation
    contract: RentContract
}


export const RentContractDocument: React.FC<RentContractDocumentProbs> = ({onCreatedRentContractDocument, contract}) => {

    const [opened, setOpened] = useState(false);


    const handleDownload = async (documentId: number, fileName: string) => {
        try {
            // Download document as Blob
            const blobData = await downloadDocument(Number(contract.id), documentId);

            // Determine MIME type and extension based on the file name or blob's type
            let mimeType = blobData.type;
            let extension = '';

            // Check if the fileName already has a valid extension
            if (fileName.toLowerCase().endsWith('.pdf')) {
                extension = '.pdf';
                mimeType = 'application/pdf';
            } else if (fileName.toLowerCase().endsWith('.docx')) {
                extension = '.docx';
                mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            } else {
                // If no extension is present, check the blob's type
                if (blobData.type === 'application/pdf') {
                    extension = '.pdf';
                } else if (
                    blobData.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                ) {
                    extension = '.docx';
                } else {
                    // Fallback to PDF if type is not recognized
                    extension = '.pdf';
                    mimeType = 'application/pdf';
                }
                fileName = fileName + extension;
            }

            // Create a new Blob with the correct MIME type
            const fileBlob = new Blob([blobData], { type: mimeType });
            const url = window.URL.createObjectURL(fileBlob);

            // Create an anchor element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            // Cleanup the DOM and URL object
            link.parentNode?.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error(err);
            alert('Failed to download the document.');
        }
    };

    return  <>
        <Button variant={"filled"} onClick={() => setOpened(true)}>Dokumente</Button>

        <Drawer
            opened={opened}
            onClose={() => setOpened(false)}
            title="Management Vertragsdokumente"
            padding="md"
            size="lg"
        >
            <Flex direction={"column"} gap={"15px"}>
                <UploadDocuments rentContractId={Number(contract.id)} onUploadSuccess={onCreatedRentContractDocument} />

                <Divider>
                </Divider>
                <Flex direction={"column"} align={"flex-start"} gap={"15px"}>
                    {contract.documents.map(doc => (
                        <Box mt="md">
                            <Card withBorder shadow="sm" padding="md">
                                <Group align="center">
                                    <Avatar size="lg" radius="sm" variant="light">
                                        <IconFile size={24} />
                                    </Avatar>
                                    <div style={{ flex: 1, marginLeft: 10 }}>
                                        <Text w={500}>{doc.fileName}</Text>
                                    </div>
                                    <Button
                                        key={doc.id}
                                        variant={"filled"}
                                        size="xs"
                                        onClick={() => handleDownload(doc.id, doc.fileName)}
                                        style={{marginRight: '5px'}}
                                        leftSection={<IconDownload size={16} />}
                                    >
                                        Herunterladen
                                    </Button>
                                </Group>
                            </Card>
                        </Box>

                    ))}
                </Flex>

            </Flex>
        </Drawer>
    </>
}